import PartnerCaseComponent from "../Components/PartnerCase/PartnerCaseComponent"
function PartnerCasePage() {
    return (
        <PartnerCaseComponent/>
    )
}

export default PartnerCasePage